/**
 * Эндпоинты для работы с поиском (search)
 */
export const SEARCH_ENDPOINTS = {
  /** GET /v1/search - Поиск контента по запросу */
  base: "/v1/search",
  /** GET /v1/search/content/advanced - Расширенный поиск контента */
  advancedContent: "/v1/search/content/advanced",
  /** GET /v1/search/person/advanced - Расширенный поиск персон */
  advancedPerson: "/v1/search/person/advanced",
} as const;
